(function () {
    'use strict';

    angular
        .module('app')
        .factory('downloadService', downloadService);

    downloadService.$inject = ['$http', '$q'];

    function downloadService($http, $q) {
        var service = {
            Download: Download,
            DownloadCleanup: DownloadCleanup,
            DownloadForIpad: DownloadForIpad
        };
        return service;

        // **************************************
        // BEGIN COMMANDS
        // **************************************

        // Call the download command with a Selection List and options
        // var options = { includeChildren: scope.includeChildren, zipFiles: scope.zipFiles, zipPassword: scope.zipPassword};
        function Download(options, selectionItemList) {
            var fileList = [];
            angular.forEach(selectionItemList.list, function (item) {
                var downloadFileModel = {
                    FileId: item.fileId,
                    MajRev: item.majRev,
                    MinRev: item.minRev,
                    TableNumber: item.tableNumber,
                    FileName: item.filename
                }
                fileList.push(downloadFileModel);
            });

            var downloadOptions = {
                IncludeChildren: options.IncludeChildren,
                ZipFiles: options.ZipFiles,
                ZipPassword: options.ZipPassword,
                FileList: fileList
            }


            var request = $http({
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("Content-Type", "application/json");
                },
                method: 'PUT',
                dataType: 'json',
                contentType: 'application/json',
                crossDomain: true,
                cache: false,
                url: '../Synergis.WebApi/api/SelectionCommand/Download',
                data: JSON.stringify(downloadOptions)
            }, function (err, status) {
                console.info('Download error', err, status);
            });
            return request;
        }

        // For the iPad - Call the download command with a Selection List and options
        function DownloadForIpad(options, selectionItemList) {
            var fileList = [];
            angular.forEach(selectionItemList.list, function (item) {
                var downloadFileModel = {
                    FileId: item.fileId,
                    MajRev: item.majRev,
                    MinRev: item.minRev,
                    TableNumber: item.tableNumber,
                    FileName: item.filename
                }
                fileList.push(downloadFileModel);
            });

            var downloadOptions = {
                IncludeChildren: options.IncludeChildren,
                ZipFiles: options.ZipFiles,
                ZipPassword: options.ZipPassword,
                FileList: fileList
            }

            var request = $http({
                headers: {
                    "Content-Type": "application/json"
                },
                method: 'PUT',
                dataType: 'json',
                contentType: 'application/json',
                crossDomain: true,
                cache: false,
                url: '../Synergis.WebApi/api/View/UrlForIPad',
                data: JSON.stringify(downloadOptions)
            });

            return request;
        }

        // Simple call to cleanup the user's temporary directory when the user closes the download dialog
        function DownloadCleanup() {
            var request = $http({
                method: 'DELETE',
                crossDomain: true,
                cache: false,
                url: '../Synergis.WebApi/api/SelectionCommand/DownloadCleanup'
            }, function (err, status) {
                console.info('DownloadCleanup error', err, status);
            });
            return request;
        }

    }
})();